export default {
  enumByKeys: state => state.enumByKeys,
  /**
	 * @argument: moduleName 枚举模块名
   * @argument: enumName 枚举名
   * @description:
   *  通过传入枚举的code值获取其message
   *  声明:
   * computed: {
   *   currencyEnum(){ return this.$store.getters.enumGetter('trade','currency') }
   * }
   *  使用例:
   *   this.currencyEnum(code)
   */
  enumGetter: (state, getter) => (moduleName, enumName) => code => getter['enumStatus'](moduleName, enumName, code),
  /**
   * @description: 处理枚举code的方法,供enumGetter使用
   */
  enumStatus: state => (moduleName, enumName, code) => {
    if (typeof code === 'object') {
      return code.message || code;
    }
    const matchingState = state?.enumByKeys?.[moduleName]?.[enumName] ?? undefined;
    if (!matchingState) {
      return code;
    }

    const matchingEnum = matchingState.find(item => item.code == code);
    return matchingEnum?.message ?? code;
  },

  enumStateArrAvue: state => (moduleName, enumName) => {
    const res = state?.enumByKeys?.[moduleName]?.[enumName]
    const arr = []
    res.map(i => arr.push({ label: i.message, value: i.code }))
    return arr || []
  },

  /**
   * @description: 获取枚举数组
   * 形如 [{code: '1',message: '出金'}, {code: '2',message: '入金'}]
   * 用法：
   * 1、引入mapState
   * 2、...mapState({
   *   xxxEnumArr: (state,getter) => getter.enumStateArr('模块名','枚举名')
   * })
   * 3、<Options
	 *      v-for="item in xxxEnumArr"
	 *      :key="item.code"
	 *      :label="item.message"
	 *      :value="item.code"
	 *    >
	 * @param state
	 * @param getter
	 * @returns {function(*, *): Array}
	 */
  enumStateArr: state => (moduleName, enumName) => state?.enumByKeys?.[moduleName]?.[enumName] ?? []

}
